import React, { useState } from 'react';

//Router dom
import { Link } from 'react-router-dom';

//Redux
import { useDispatch, useSelector } from 'react-redux';

//CSS
import '../../Admin/Header/adminHeader.css';

//Actions
import { costOfSaleInfo, getIncompleteOrders } from '../../../actions/admin';
import { logout } from '../../../actions/user';

//XLSX
import XLSX from 'sheetjs-style';

//File saver
import * as FileSaver from 'file-saver';

//Date fns
import { format } from 'date-fns';

//MUI
import {
    Typography, ListItemButton, Backdrop, Stack, Collapse, List, Menu, Avatar, Divider, MenuItem, IconButton, ListItemIcon, ListItemText
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import HomeIcon from '@mui/icons-material/Home';

//Drawer list data
import { data } from './DrawerListData';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

const drawerPermissions = {
    productos: 'products',
    'productos-odoo': 'products',
    'categorias-productos': 'product_data',
    'marcas-productos': 'product_data',
    'orden-productos': 'product_data',
    'comentarios-productos': 'reviews',
    pedidos: 'orders',
    'pedidos-incompletos': 'orders',
    'carrito-abandonado': 'orders',
    'metodos-envio': 'shipping',
    cupones: 'coupons',
    promociones: 'promotions',
    'directorio-medico': 'doctors',
    'nuevo-medico': 'doctors',
    'pedidos-medicos': 'doctors',
    'resumen-medicos': 'doctors',
    'cupones-medicos': 'coupons',
    admins: 'admins',
    'banners-tienda': 'banners',
    blog: 'blog',
    'nuevo-blog': 'blog',
    contacto: 'contact',
    clientes: 'clients'
};

const DrawerList = (props) => {
    const dispatch = useDispatch();
    const { loggedUser: { username, privileges = {} } } = useSelector(state => state.user);
    const visibleData = data
        .map(section => ({
            ...section,
            submenu: section.submenu.filter(item => {
                const privilege = drawerPermissions[item.url];
                return !privilege || Boolean(privileges[privilege]);
            })
        }))
        .filter(section => section.submenu.length > 0);

    // cerrar sesión
    const logout_fn = () => {
        dispatch(logout());
    };

    const [uiState, setUiState] = useState({
        open: false,
        text: 'reporte'
    });
    const { open, text } = uiState;

    //Menu avatar
    const [anchorElUser, setAnchorElUser] = useState(null);
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    // generar reporte de Webinar NIN
    const webinarReport = async () => {
        window.location.href = 'https://www.nefropolis.com/reporte_webinar/report.php';
    };

    // generar reporte de costo de venta
    const costOfSale = async () => {
        setUiState(e => ({ ...e, open: true, text: 'reporte' }));
        const req = await costOfSaleInfo();
        if (req.status)
            exportToExcel(req.resp, `costo_ventas${format(new Date(), '_dd_MM_yyyy')}`);
        setUiState(e => ({ ...e, open: false }));
    };

    const incompleteOrders = async () => {
        setUiState(e => ({ ...e, open: true, text: 'archivo' }));
        const req = await getIncompleteOrders();
        if (req.status)
            exportToExcel(req.resp, `pedidos_incompletos${format(new Date(), '_dd_MM_yyyy')}`);
        setUiState(e => ({ ...e, open: false }));
    };

    const exportToExcel = async (array, name) => {
        const ws = XLSX.utils.json_to_sheet(array);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
            data, `${name}${fileExtension}`
        );
    };

    const [expanded, setExpanded] = useState(false);

    const handleOpen = (index) => {
        if (expanded === index) {
            setExpanded(false);
        } else {
            setExpanded(index);
        }
    };

    const specialCases = {
        'reporte-webinar': {
            component: undefined,
            to: undefined,
            onClick: webinarReport,
            withDivider: false
        },
        'costo-ventas': {
            component: undefined,
            to: undefined,
            onClick: costOfSale,
            withDivider: true
        },
        'incompletos': {
            component: undefined,
            to: undefined,
            onClick: incompleteOrders,
            withDivider: true
        }
    };

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}>
                <Stack direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}>
                    <Typography variant='body1'>{`Generando ${text}...`}</Typography>
                    <CircularProgress color="inherit" fontSize="small" />
                </Stack>
            </Backdrop>
            <div className='img-admin-sidebar-header bg-wrap'>
                <div className="user-logo">
                    <Avatar
                        sx={{ backgroundColor: '#2699FB', fontWeight: 'bold' }}
                        className='img-user-logo'>
                        {username.charAt(0)}
                    </Avatar>
                    <div>
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                            <Typography variant='body1'
                                sx={{ fontWeight: '600', color: '#ffff' }}>
                                {username} <ArrowDropDownIcon />
                            </Typography>
                        </IconButton>
                        <Typography variant="caption" display="block" gutterBottom
                            sx={{ color: '#ffff' }}>
                            Versión 3.0
                        </Typography>
                        <Menu
                            sx={{ mt: '25px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem onClick={logout_fn}><LogoutIcon sx={{ mr: 2 }} />
                                Cerrar sesión
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            </div>

            <List disablePadding>
                <ListItemButton
                    onClick={props.open}
                    sx={[
                        {
                            bgcolor: '#F2F3F4',
                            borderBottom: '1px solid #F2F3F4'
                        },
                        {
                            '&:hover': {
                                backgroundColor: '#EAEDED'
                            }
                        }
                    ]}
                    component={Link}
                    to='/nefro-admin/'
                >
                    <ListItemIcon><HomeIcon /></ListItemIcon>
                    <ListItemText primary={'Panel'} />
                </ListItemButton>
                {
                    visibleData.map((res, index) => (
                        <React.Fragment key={index}>
                            <ListItemButton onClick={() => handleOpen(index)}
                                sx={[
                                    {
                                        bgcolor: '#F2F3F4',
                                        borderBottom: '1px solid #F2F3F4'
                                    },
                                    {
                                        '&:hover': {
                                            backgroundColor: '#EAEDED'
                                        }
                                    }
                                ]}
                            >
                                <ListItemIcon>
                                    {res.icon}
                                </ListItemIcon>
                                <ListItemText primary={res.name} />
                                {expanded === index ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={expanded === index} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {
                                        res.submenu.map(({ icon, title, url }) => {
                                            const Icon = icon;
                                            const cfg = specialCases[url] || {
                                                component: Link,
                                                to: `/nefro-admin/${url}`,
                                                onClick: props.open,
                                                withDivider: true
                                            };

                                            return (
                                                <React.Fragment key={url}>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        onClick={cfg.onClick}
                                                        component={cfg.component}
                                                        to={cfg.to}
                                                    >
                                                        <ListItemIcon><Icon /></ListItemIcon>
                                                        <ListItemText primary={title} />
                                                    </ListItemButton>

                                                    {cfg.withDivider && <Divider />}
                                                </React.Fragment>
                                            );
                                        })
                                    }
                                </List>
                            </Collapse>
                        </React.Fragment>
                    ))
                }
            </List>
        </>
    );
};

export default DrawerList;
